import { NavMenuItemText } from './NavMenuItemText';
import { Props } from './props';

export * from './NavMenuItemText';

export type NavItemProps = Props;

export default NavMenuItemText;
